// extracted by mini-css-extract-plugin
export var quillEditor = "_of-1";
export var variable = "_of-0";